import { Ship } from '../model/ship';
import { Graphics } from './graphics';
import { Point, neighbors, equals } from '../math/point';
import { range } from '../math/util';
import { GREEN_LINE, YELLOW_LINE, WHITE_LINE, DARK_GREEN_LINE, GRAY_LINE, BLACK_LINE, DARK_DARK_GREEN_LINE, THICK_GREEN_LINE, LineStyle } from './lines';
import { Angle } from '../math/angle';
import { GREEN, BLACK, Color, RED, BLUE } from './color';
import { WorldGrid } from '../model/world-grid';
import { hLineByMidpoint, vLineByMidpoint } from '../math/line';

const GREEN_DOT = GREEN //.setAlpha(0.25)
const RED_DOT = RED //.setAlpha(0.25)
const BLUE_DOT = BLUE //.setAlpha(0.25)

export class ShipDisplay {
  // TODO: remove magic number
  readonly shipRadius = 5

  constructor(readonly graphics: Graphics) {}

  drawMove(gameGrid: WorldGrid, p: Point, ship: Ship, allowed: boolean) {

    const allowedMoves = neighbors(gameGrid.toGrid(ship.position), gameGrid.toGridScalar(ship.speed)).
        map(p => gameGrid.toWorld(p)).
        filter(p => ship.canMove(p)).
        filter(p => !equals(p, gameGrid.snap(ship.position)))

    this.graphics.fillStyle(BLUE_DOT)
    allowedMoves.forEach(p0 => this.graphics.point(p0))

    const style = new LineStyle(new Color(0x55, 0x55, 0x55), 2)
    this.graphics.lineStyle(style)
    allowedMoves.forEach(p0 => this.drawAllowedMoved(p0))
    if (allowed && !equals(p, gameGrid.snap(ship.position))) {
      const style2 = new LineStyle(new Color(0x00, 0xFF, 0x00), 2)
      this.graphics.lineStyle(style2)
      this.drawAllowedMoved(p)

      const fill = new Color(0x00, 0xFF, 0x00, 0.75)
      // const fill = new Color(0x00, 0xFF, 0x00, 0.25)
      // this.graphics.fillStyle(fill)
      // this.graphics.square(p)
      const fill2 = new Color(0x00, 0xFF, 0x00, 1.0)
      this.graphics.fillStyle(fill2)
      this.graphics.point(p)
      this.drawSelectedMove(p)

      // const style = new LineStyle(new Color(0xFF, 0xFF, 0xFF), 4)
      // this.graphics.lineStyle(style)
      // this.graphics.line(ship.position, p)
    }




    // this.graphics.parabola(ship.position, ship.heading, ship.speed, ship.turnSpeed)
  }

  private drawAllowedMoved(p0: Point) {
    const fill = new Color(0x00, 0xFF, 0x00, 0.5)
    // const fill = new Color(0x00, 0xFF, 0x00, 0.25)
    this.graphics.fillStyle(fill)
    // this.graphics.square(p0)

        // draw cursor highlight
        // const hLine1 = hLineByMidpoint(new Point(p0.x, p0.y-5), 5)
        // const hLine2 = hLineByMidpoint(new Point(p0.x, p0.y+5), 5)
        // const vLine1 = vLineByMidpoint(new Point(p0.x-5, p0.y), 5)
        // const vLine2 = vLineByMidpoint(new Point(p0.x+5, p0.y), 5)
        // this.graphics.drawLine(hLine1)
        // this.graphics.drawLine(hLine2)
        // this.graphics.drawLine(vLine1)
        // this.graphics.drawLine(vLine2)
  }

  private drawSelectedMove(p0: Point) {
    const fill = new Color(0x00, 0x00, 0xFF, 1)
    // const fill = new Color(0x00, 0xFF, 0x00, 0.25)
     this.graphics.fillStyle(fill)
    // this.graphics.square(p0)
    this.graphics.lineStyle(new LineStyle(fill, 2))
        // draw cursor highlight
        const hLine1 = hLineByMidpoint(new Point(p0.x, p0.y-5), 5)
        const hLine2 = hLineByMidpoint(new Point(p0.x, p0.y+5), 5)
        const vLine1 = vLineByMidpoint(new Point(p0.x-5, p0.y), 5)
        const vLine2 = vLineByMidpoint(new Point(p0.x+5, p0.y), 5)
        this.graphics.drawLine(hLine1)
        this.graphics.drawLine(hLine2)
        this.graphics.drawLine(vLine1)
        this.graphics.drawLine(vLine2)
  }

  private drawShield(ship: Ship, quadrant: number) {
    const r = 1.0 * this.shipRadius

    const ratio = ship.shields[quadrant]/ ship.maxShields[quadrant]
    const index = Math.min(Math.floor(ratio * 2) + 1, 4)

    switch (index) {
      case 4: this.graphics.lineStyle(THICK_GREEN_LINE); break;
      case 3: this.graphics.lineStyle(GREEN_LINE); break;
      case 2: this.graphics.lineStyle(DARK_GREEN_LINE); break;
      case 1: this.graphics.lineStyle(DARK_DARK_GREEN_LINE); break;
      default: this.graphics.lineStyle(BLACK_LINE); break;
    }

    //

    this.quadrantArc(ship.position, r, ship.quadrantAngle(quadrant))
  }

  private drawShields(ship: Ship) {
    this.graphics.lineStyle(GREEN_LINE)

    const xs = range(4)

    for (const x of xs) {
      if (ship.shields[x] > 0) {
        this.drawShield(ship, x)
      }
    }
  }

  private quadrantArc(p: Point, r: number, angle: number) {
    this.graphics.arc(p, r, Angle.PI_4+angle, -Angle.PI_4+angle)
  }

  drawQuadrantArc(ship: Ship, quadrant: number) {
    const r = 1 * this.shipRadius


    this.quadrantArc(ship.position, r, ship.quadrantAngle(quadrant))
  }

  draw(ship: Ship) {
    this.graphics.image(ship.sprite.image, ship.position, ship.heading)

    this.drawShields(ship)
  }
}